import React from "react";
import PropTypes from "prop-types";

import { Card, Image } from "semantic-ui-react";

export function CrmOption({ name, imgUrl, selected, onClick }) {
  return (
    <Card
      onClick={onClick}
      style={{
        cursor: "pointer",
        width: "200px",
        border: "1px solid",
        borderColor: selected ? "#2185D0" : "lightgray",
      }}
      className="grey_on_hover"
      data-test="crm-button"
    >
      <Card.Content
        style={{
          display: "flex",
          alignItems: "center",
          padding: "20px",
        }}
      >
        <Card.Header
          style={{
            fontSize: "22px",
            fontFamily: "Helvetica",
            fontWeight: "bold",
            paddingRight: "16px",
          }}
        >
          {name}
        </Card.Header>
        <Image size="mini" src={imgUrl} alt={`${name} logo`} />
      </Card.Content>
    </Card>
  );
}

CrmOption.propTypes = {
  name: PropTypes.string.isRequired,
  imgUrl: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default CrmOption;
